var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('mini-relative-date',{attrs:{"value":_vm.from},on:{"update:value":function($event){_vm.from=$event}}}),_c('i',{staticClass:"fa-solid fa-arrow-right m-auto text-info"}),_c('mini-relative-date',{attrs:{"value":_vm.to},on:{"update:value":function($event){_vm.to=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }